<template>
  <div class="col-lg-8 col-md-8 col-sm-12 mx-auto">
    <b-skeleton width="8%" height="48px" class="mt-4 mx-auto" />
    <b-skeleton width="100%" height="32px" class="mt-4 mx-auto" />
    <b-skeleton width="80%" height="20px" class="mx-auto" />
    <b-skeleton height="100px" />
    <b-skeleton height="24px" width="40%" class="mt-4" />
    <b-skeleton height="24px" width="100%" class="mt-1" />
    <b-skeleton height="24px" width="100%" />
    <b-skeleton height="24px" width="100%" />
    <b-skeleton height="24px" width="100%" />
    <b-skeleton height="24px" width="100%" />
  </div>
</template>

<script>
export default {
  name: 'EvaAgentSkeleton'
}
</script> 